import React from "react";
import { connect } from "react-redux";
import CustomScroll from "react-custom-scroll";

import DocumentTypeFilters from "./DocumentTypeFilters";
import MetadataFilters from "./MetadataFilters";

const SearchFilters = ({
  _,
  updateDigitalFilters,
  searchParameters,
  metadataFiltersExist,
  DocumentTypes,
}) => {
  const { metadataFilterCollection } = searchParameters;

  return (
    DocumentTypes && (
      <div className="search-options-area digital-search-options-area">
        <CustomScroll heightRelativeToParent={"200px"} allowOuterScroll={true}>
          <div className="row">
            <div
              className="col search-checkboxes d-flex flex-row"
              key={"documentTypeFilters"}
            >
              {DocumentTypes && (
                <DocumentTypeFilters
                  _={_}
                  searchParameters={searchParameters}
                  DocumentTypes={DocumentTypes}
                  updateDigitalFilters={updateDigitalFilters}
                />
              )}
              {metadataFiltersExist && (
                <MetadataFilters
                  _={_}
                  metadataFilterCollection={metadataFilterCollection}
                  updateDigitalFilters={updateDigitalFilters}
                />
              )}
            </div>
          </div>
        </CustomScroll>
      </div>
    )
  );
};

export const mapStateToProps = ({ _, User }) => ({ _, User });
export default connect(mapStateToProps)(SearchFilters);
